import { useNavigate } from "react-router-dom";
import { CustomRadio } from "../../../../components";
import "./style.scss";

const ChannelRadio = ({ methods, methodsValue, setMethodsValue, className }) => {
  const navigate = useNavigate();

  return (
    <div className={`channel-radio ${className}`}>
      <CustomRadio
        items={methods}
        value={methodsValue}
        onClick={(e) => setMethodsValue(e.target.value)}
        onClickAdd={() => navigate("/user/withdrawAddress?tab=withdrawAddress")}
        showCheck={true}
        type="radio"
      />
    </div>
  );
};

export default ChannelRadio;
